module.exports = __webpack_public_path__ + "img/add-picture.35a3b23c.svg";